import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class MyDateAdapter extends NativeDateAdapter {

  getFirstDayOfWeek(): number {
    return 1;
  }

  parse(value: any): Date | null {
    if (typeof value === 'string' && value.indexOf('/') > -1) {
      const [day, month, year] = value.split('/').map(Number);
      if (!day || !month || !year) return null;
      return new Date(Date.UTC(year, month - 1, day));
    }

    const timestamp = typeof value === 'number' ? value : Date.parse(value as string);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }

  format(date: Date, displayFormat: any): string {
    if (!date) return '';

    const dtf = new Intl.DateTimeFormat(this.locale, {
      ...displayFormat,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });

    return dtf.format(date).replace(/[\u200e\u200f]/g, '');
  }
}
